"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EndOfDayModule = /** @class */ (function () {
    function EndOfDayModule() {
    }
    return EndOfDayModule;
}());
exports.EndOfDayModule = EndOfDayModule;
